<template>
  <div>
    <el-form-item :label="$t('i18n.b985c54ec0b64c37852c22562475f1ce')" prop="name">
      <el-input
        v-model="form.name"
        maxlength="50"
        show-word-limit
        :placeholder="$t('i18n.a6d61a9d34474ef5bcbb83938e05c756')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('i18n.78209f56e1884816bad4aac43c7a1a7b')" prop="region">
      <el-input
        v-model="form.tips"
        maxlength="100"
        show-word-limit
        :placeholder="$t('i18n.2afee910006744ee82e19faabf3add31')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('i18n.d44c914aa92a46b6870320cdb0087b5c')" prop="region">
      <el-select v-model="form.currency" :placeholder="$t('221')" filterable>
        <el-option v-for="(item, key) in this.currenyOptions" :key="key" :label="item.currency" :value="key">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('i18n.74a02782b927487caf05dab6b7cf59d1')" prop="region">
      <el-checkbox v-model="form.isThousandth">{{ $t('0f620b32') }}</el-checkbox>
      <el-checkbox v-model="form.isPrecision">
        <span>{{ $t('620b32bd') }}</span>
        <el-input-number
          class="short-select"
          v-model="form.precision"
          controls-position="right"
          :min="1"
          :max="10"
        ></el-input-number>
        <span>{{ $t('f620b32b') }}</span>
      </el-checkbox>
    </el-form-item>
    <el-form-item :label="$t('i18n.0a5d225866204083972f74127963080b')" prop="region">
      <el-checkbox v-model="form.require">{{ $t('i18n.ca2f54a11aaf46d49f46588e55bbab1a') }}</el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
import { getCurrency } from '@/api/flow'
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      checked: false,
      currenyOptions: []
    }
  },
  created() {
    this.getCurrency()
  },
  methods: {
    async getCurrency() {
      const res = await getCurrency()
      this.currenyOptions = res.data
    }
  }
}
</script>
